import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../utils/axios';
import logo from '../../assets/Venzo-Logo.png.webp';

const ResetPasswordPage = () => {
    const navigate = useNavigate();
    const { id, token } = useParams();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false); // Added success state
    const [alert, setAlert] = useState({ show: false, message: '', type: '' });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setAlert({ show: false, message: '', type: '' });

        if (password !== confirmPassword) {
            setAlert({
                show: true,
                message: 'Passwords do not match',
                type: 'error'
            });
            return;
        }

        if (password.length < 6) {
            setAlert({
                show: true,
                message: 'Password must be at least 6 characters',
                type: 'error'
            });
            return;
        }

        setLoading(true);

        try {
            await api.post('/users/reset-password', { id, token, password });
            setLoading(false);
            setAlert({
                show: true,
                message: 'Password reset successful!',
                type: 'success'
            });

            setSuccess(true);
            setAlert({
                show: true,
                message: 'Password reset successful! You can now login.',
                type: 'success'
            });
            // No redirect, just show success state

        } catch (err) {
            console.error('Reset password error:', err);
            setLoading(false);
            setAlert({
                show: true,
                message: err?.response?.data?.message || 'Failed to reset password. Link might be expired.',
                type: 'error'
            });
        }
    };

    return (
        <div style={{
            minHeight: '100vh',
            background: '#fff',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '0 16px'
        }}>
            {/* Status bar space */}
            <div style={{ height: 32 }} />

            {/* Logo */}
            <img src={logo} alt="Venzo Logo"
                style={{ width: 90, margin: '12px auto 16px auto', display: 'block' }}
            />

            {/* Alert message */}
            {alert.show && (
                <div style={{
                    marginBottom: 18,
                    background: alert.type === 'success' ? '#e3ffe8' : '#ffe1e1',
                    color: alert.type === 'success' ? '#187439' : '#b30000',
                    padding: "10px 15px",
                    borderRadius: 7,
                    fontSize: 15,
                    fontWeight: 500,
                    border: alert.type === 'success' ? '1.2px solid #94e7b1' : '1.2px solid #fbbebe',
                    width: '100%',
                    maxWidth: 340,
                    textAlign: 'center'
                }}>{alert.message}</div>
            )}

            {/* Reset Password form or Success Message */}
            {success ? (
                <div style={{
                    textAlign: 'center',
                    maxWidth: 350,
                    width: '100%',
                    padding: '20px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}>
                    <div style={{ fontSize: 60, marginBottom: 20 }}>🎉</div>
                    <h2 style={{ margin: '0 0 10px 0', color: '#222' }}>Password Reset!</h2>
                    <p style={{ color: '#666', marginBottom: 30, fontSize: 16 }}>
                        Your password has been successfully updated. You can now close this window and login to the app.
                    </p>

                    <a href="https://app.venzowood.com" style={{
                        textDecoration: 'none',
                        background: '#000',
                        color: '#fff',
                        padding: '12px 24px',
                        borderRadius: 6,
                        fontWeight: 600,
                        fontSize: 16,
                        display: 'block',
                        width: '100%',
                        boxSizing: 'border-box'
                    }}>
                        Open App
                    </a>
                </div>
            ) : (
                <form
                    onSubmit={handleSubmit}
                    style={{
                        width: '100%',
                        maxWidth: 350,
                        background: 'transparent',
                        margin: '0 auto',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <h1 style={{
                        fontWeight: 700,
                        fontSize: 28,
                        marginBottom: 6,
                        marginTop: 0,
                        color: '#222'
                    }}>
                        Reset Password
                    </h1>
                    <div style={{
                        color: '#667085',
                        marginBottom: 22,
                        fontSize: 16
                    }}>
                        Enter your new password below.
                    </div>

                    {/* Password field */}
                    <label style={{
                        fontWeight: 500,
                        fontSize: 13,
                        letterSpacing: 1,
                        color: '#333',
                        marginBottom: 4
                    }}>
                        NEW PASSWORD
                    </label>
                    <input
                        type="password"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        required
                        style={{
                            width: '100%',
                            padding: '13px 12px',
                            border: '1.5px solid #e1e1e1',
                            borderRadius: 6,
                            fontSize: 16,
                            outline: 'none',
                            marginBottom: 16,
                            background: '#fff'
                        }}
                        placeholder="Min 6 characters"
                    />

                    {/* Confirm Password field */}
                    <label style={{
                        fontWeight: 500,
                        fontSize: 13,
                        letterSpacing: 1,
                        color: '#333',
                        marginBottom: 4
                    }}>
                        CONFIRM PASSWORD
                    </label>
                    <input
                        type="password"
                        value={confirmPassword}
                        onChange={e => setConfirmPassword(e.target.value)}
                        required
                        style={{
                            width: '100%',
                            padding: '13px 12px',
                            border: '1.5px solid #e1e1e1',
                            borderRadius: 6,
                            fontSize: 16,
                            outline: 'none',
                            marginBottom: 22,
                            background: '#fff'
                        }}
                        placeholder="Re-enter password"
                    />

                    {/* Submit Button */}
                    <button
                        type="submit"
                        disabled={loading}
                        style={{
                            width: '100%',
                            padding: '14px',
                            background: loading ? '#ccc' : '#000',
                            color: '#fff',
                            border: 'none',
                            borderRadius: 6,
                            fontSize: 16,
                            fontWeight: 600,
                            cursor: loading ? 'not-allowed' : 'pointer',
                            marginBottom: 16
                        }}
                    >
                        {loading ? 'Resetting...' : 'Reset Password'}
                    </button>

                    {/* Back to Login */}
                    <div style={{ textAlign: 'center' }}>
                        <button
                            type="button"
                            onClick={() => navigate('/login')}
                            style={{
                                background: 'none',
                                border: 'none',
                                color: '#007bff',
                                fontSize: 15,
                                fontWeight: 500,
                                cursor: 'pointer',
                                textDecoration: 'none',
                                padding: '8px 0'
                            }}
                            onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                            onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            )}
        </div>
    );
};

export default ResetPasswordPage;
